const config = {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080', // Default to localhost for safety
};

export default config;